import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

export interface BreadcrumbItem {
  label: string;
  url?: string;
  active?: boolean;
}

@Injectable({
  providedIn: "root",
})
export class BreadcrumbService {
  private breadcrumbsSubject = new BehaviorSubject<BreadcrumbItem[]>([]);
  public breadcrumbs$: Observable<BreadcrumbItem[]> = this.breadcrumbsSubject.asObservable();

  constructor() {}

  setBreadcrumbs(breadcrumbs: BreadcrumbItem[]) {
    this.breadcrumbsSubject.next(breadcrumbs);
  }

  addBreadcrumb(breadcrumb: BreadcrumbItem) {
    const currentBreadcrumbs = this.breadcrumbsSubject.value;
    this.breadcrumbsSubject.next([...currentBreadcrumbs, breadcrumb]);
  }

  clearBreadcrumbs() {
    this.breadcrumbsSubject.next([]);
  }

  // Predefined breadcrumbs for Digital Memory Log
  setDigitalMemoryLogListBreadcrumbs() {
    this.setBreadcrumbs([
      { label: "Home", url: "/overview" },
      { label: "Travel Guide List", active: true },
    ]);
  }

  setCreateDigitalMemoryLogBreadcrumbs(groupId?: string) {
    this.setBreadcrumbs([
      { label: "Home", url: "/overview" },
      { label: "Travel Guide List", url: "/overview/user/digital-memory-logs" },
      { label: "Create Travel Guide", active: true },
    ]);
  }

  setEditDigitalMemoryLogBreadcrumbs(groupId?: string, digitalMemoryLogName?: string) {
    this.setBreadcrumbs([
      { label: "Home", url: "/overview" },
      { label: "Travel Guide List", url: "/overview/user/digital-memory-logs" },
      { label: digitalMemoryLogName || "Edit Travel Guide", active: true },
    ]);
  }
}
